import React, {Component} from 'react';
import styles from "./AssociaSegnalazioni.module.css";
import Table from "../../../../components/table/Table";
import Button from "../../../../components/button/Button";
import OggettiUtili from "../../../../utils/OggettiUtili";
import Utils from '../../../../utils/Utils';
import {withTranslation} from "react-i18next";
import SegnalazioniServices from "../../../../services/SegnalazioniServices";
import toasterConfig from "../../../../config/toasterConfig";
import Spinner from "../../../../components/spinner/Spinner";
import ToasterSingleton from "../../../../singleton/ToasterSingleton";
import SessioneUtente from "../../../../sessionManager/SessioneUtente";
import {states} from '../../../Wizard/States/States';
import FocolaiServices from "../../../../services/FocolaiServices";
import Ruoli from "../../../../utils/Ruoli.json";

class AssociaSegnalazioni extends Component {

    state = {
        rows: [],
        totalElements: 0,
        page: 0,
        totalPages: 0,
        size: 10,
        loading: false,
        segnalazioniSelezionate: [],
        filtri: {
            malattia: "",
            cognome: "",
            dataDa: "",
            dataA: ""
        },
        sections: {     //campo contenente le info di stato di InformazioniFocolaio
                idFocolaio:"",
                malattia: "",
                regione: "",
                provincia: "",
                comune: "",
                indirizzo: "",
                recapito: "",
                numeroCasi: "",
                comunita: "",
                comunitaAltro: "",
                numeroPersoneRischio: "",
                luogoOrigine: "",
                dataInizio: "",
                dataCompilazione:"",
                durata: "",
                agente: "",
                veicolo: "",
                agenteId: 0,
                veicoloId: 0,
                etichetta: "",
                note: ""
        },
        isModifica: false,
        malattie: JSON.parse(sessionStorage.getItem("malattie")),
        sendRequest: false,
        oldParams: {}
    }



    cols = [
        {key: "checked", name: "", tipo: "checkbox"},
        {
            key: "idSegnalazione", name: "ID Segnalazione", sortDirection: "none",
            nomeParametro: "idSegnalazione",
            state: {currentState: states.DATI_SEGNALAZIONE_E_ANAGRAFICI}
        },
        {key: "malattia", name: "Malattia", sortDirection: "none"},
        {key: "paziente", name: "Paziente", sortDirection: "none"},
        {
            key: "ulssAppartenenza",
            name: "Ulss Paziente",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.Ulss
        },
        {key: "dataSegnalazione", name: "Data Segnalazione", sortDirection: "none", tipo: "data"},
        {
            key: "statoSegnalazione",
            name: "Stato",
            sortDirection: "none",
            tipo: "pallino",
            oggetto: OggettiUtili.statoSegnalazione
        },

    ]

    rows = [
        {
            malattia: {
                id: "malattia",
                text: "malattia",
                tipo: "selectAutocomplete",
                field: "malattia",
                numeroCol: 1,
                row: 1,
                suggestions: this.state.malattie,
                keyField: "codice",
                descriptionField: "codDesc",
                suggestionField: "descrizione",
                disabled: true
            },
            cognome: {id: "cognome", text: "cognome", tipo: "input", field: "cognome", numeroCol: 2, row: 1},
            dataDa: {
                id: "dataDa",
                text: "dataDa",
                tipo: "data",
                field: "dataDa",
                placeholder: "segnalazione da",
                numeroCol: 3,
                row: 1
            },
        },
        {
            dataA: {
                id: "dataA",
                text: "dataA",
                tipo: "data",
                field: "dataA",
                placeholder: "segnalazione a",
                numeroCol: 3,
                row: 1
            },
        }
    ]

    constructor(props) {
        super(props);
        if (this.props.location.infoState) {
            this.state.sections = this.props.location.infoState.sections;
            this.state.isModifica = this.props.location.infoState.isModifica;
            this.state.filtri.malattia = this.props.location.infoState.sections.malattia
        }
        this.selectRow = this.selectRow.bind(this)
        this.setStateGenerico = this.setStateGenerico.bind(this)
        this.backToAssociaFocolaio = this.backToAssociaFocolaio.bind(this);
        this.aggiungiToaster = this.aggiungiToaster.bind(this);
        this.changePageTable = this.changePageTable.bind(this);
        this.changePaginationTable = this.changePaginationTable.bind(this);
        this.saveBozzaFocolaio = this.saveBozzaFocolaio.bind(this);
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione()
    }

    componentDidMount() {
        ToasterSingleton.instance().sottoscrizione(this)
        let object = {
            stato: this.state.filtri,
            setStatePadre: this.setStateGenerico,
            rows: this.rows,
            applicaFiltri: () => {
                this.sendRequest(this.buildParams(this.state.filtri, true, 0))
            }
        }
        this.props.creaFiltri({filtri: object})

        this.sendRequest(this.buildParams())
    }

    setStateGenerico(object) {
        this.setState(object)
    }

    buildParams(andParams, sendRequest, page, size) {

        let params = {
            ulss: SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp.descrizione
                || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione
                ? SessioneUtente.getInstance().ulss : null,
            associabili: true,
            idSessioneFocolaio: this.props.location.infoState.idSessioneFocolaio,
            page: page || page === 0 ? page : this.state.page,
            size: size ? size : this.state.size,
        };

        if (this.state.sections.malattia)
            params["malattia"] = this.state.sections.malattia;


        if (andParams && sendRequest) {
            let paramsFinale = JSON.parse(JSON.stringify(andParams))
            if (paramsFinale.dataDa)
                paramsFinale.dataDa = Utils.transformDateForBackend(paramsFinale.dataDa)
            if (paramsFinale.dataA)
                paramsFinale.dataA = Utils.transformDateForBackend(paramsFinale.dataA)
            params = Object.assign(params, paramsFinale)

        } else {
            let paramsOld = JSON.parse(JSON.stringify(this.state.oldParams))

            params = Object.assign(params, paramsOld)

        }

        let object = JSON.parse(JSON.stringify(params))

        this.setState({sendRequest: sendRequest})

        return Utils.removeEmptyValueFromObject(object);

    }

    sendRequest(params) {

        if (params.size)
            this.setState({loading: true, size: params.size});
        else
            this.setState({loading: true});

        SegnalazioniServices.getSegnalazioni(params)
            .then((data) => {
                if (!data.data.content || data.data.content.length == 0) {
                    this.aggiungiToaster();
                }
                let res = SegnalazioniServices.mapGetSegnalazioni(data);
                for (let i in res) {
                    if (Utils.checkObjectInArrayByObjectId(this.state.segnalazioniSelezionate, "idSegnalazione", res[i].idSegnalazione) > -1)
                        res[i]["checked"] = true
                    else
                        res[i]["checked"] = false
                }
                this.setState({
                    rows: res, totalElements: data.data.totalElements,
                    totalPages: data.data.totalPages, page: params.page,
                    loading: false
                });
            })
            .catch(() => {
                console.log("[Error] GetSegnalazioni in errore ");

                this.setState({rows: [], totalElements: 0, loading: false});
            });
    }

    changePageTable(sort, direction, page, size) {

        let params = this.buildParams(this.state.filtri ? this.state.filtri : null, this.state.sendRequest);

        if (size != null) {
            if (size !== this.state.size) {
                params.size = this.state.size
            } else {
                params.size = size
            }
        }

        params.page = page;

        if (sort !== null) {
            params.sort = sort
        }

        if (direction !== null) {
            params.order = direction
        }

        this.sendRequest(params);
    }


    changePaginationTable(sort, direction, page, size) {
        let params = this.buildParams(this.state.filtri ? this.state.filtri : null, this.state.sendRequest);

        if (sort !== null) {
            params.sort = sort
        }

        if (direction !== null) {
            params.order = direction
        }

        params.page = page;
        params.size = size;

        this.sendRequest(params);
    }


    aggiungiToaster() {

        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.informational,
            text: ["Toasters.Messages.no_result"],
            timestamp: Date.now()

        })
        this.forceUpdate();
    }

    saveBozzaFocolaio() {
        let dataInizio = Utils.transformDateForBackend(this.state.sections.dataInizio);
        let dataCompilazione = Utils.transformDateForBackend(this.state.sections.dataCompilazione);
        let jsonInsert = JSON.parse(JSON.stringify(this.state.sections));
        jsonInsert["malattia"] = this.state.sections.malattia;
        jsonInsert["ulss"] = SessioneUtente.getInstance().ulss;
        jsonInsert["regione"] = this.state.sections.regione.codice;
        jsonInsert["provincia"] = this.state.sections.provincia.codice;
        jsonInsert["comune"] = this.state.sections.comune.codice;
        jsonInsert["comunita"] = this.state.sections.comunita.codice;
        jsonInsert["dataInizioEpidemia"] = dataInizio;
        jsonInsert["dataCompilazione"] = dataCompilazione;
        jsonInsert["statoAgente"] = this.state.sections.agenteId;
        jsonInsert["statoVeicolo"] = this.state.sections.veicoloId;
        jsonInsert["nomeAgente"] = this.state.sections.agente.codice;
        jsonInsert["nomeVeicolo"] = this.state.sections.veicolo;

        jsonInsert["flagBozza"] = true;

        FocolaiServices.postInserimentoFocolaio(Utils.removeEmptyValueFromObject(jsonInsert))
            .then((data) => {

                if (data && data.status === 200) {
                    if (data.data && data.data.idFocolaio) {
                        this.callAssociaFocolaio(data.data.idFocolaio)
                    }
                }
            }).catch(err => {
            console.log("[ERR] Error while save");
            console.log(err);
        });
    }

    callAssociaFocolaio(idFocolaio) {

        let jsonRequest = {
            segnalazioniAssociate: Utils.objectToFieldArray(this.state.segnalazioniSelezionate, "idSegnalazione")
        };

        SegnalazioniServices.putAssociaFocolaio(idFocolaio, jsonRequest, this.props.location.infoState.idSessioneFocolaio)
            .then((data) => {
                if (data && data.status === 200) {
                    this.backToAssociaFocolaio(idFocolaio);
                }
            }).catch(() => {
            console.log("[ERR] Error put associa focolaio");
        });
    }

    backToAssociaFocolaio(idFocolaio) {
        let statoInfo = this.props.location.infoState

        if (idFocolaio)
            statoInfo["sections"]["idFocolaio"] = idFocolaio

        if (this.state.segnalazioniSelezionate) {
            statoInfo.segnalazioniDaAssociare.concat(this.state.segnalazioniSelezionate);
        }

        this.props.history.push({
            pathname: '/InformazioniFocolaio',
            infoState: statoInfo,
            segnalazioniDaAssociare: this.state.segnalazioniSelezionate ?
                statoInfo.segnalazioniDaAssociare.concat(Utils.objectToFieldArray(this.state.segnalazioniSelezionate, "idSegnalazione")) : statoInfo.segnalazioniDaAssociare
        });
    }

    selectRow(row, isChecked) {

        let selected = this.state.segnalazioniSelezionate;

        if (isChecked) {
            selected.push(row)
        } else {
            let i = Utils.checkObjectInArrayByObjectId(selected, "idSegnalazione", row.idSegnalazione);
            selected.splice(i, 1);
        }

        this.setState({
            segnalazioniSelezionate: selected
        });

    }

    render() {
        const {t} = this.props;

        const tableDiv = (
            <div className="container mt-3">
                <div className={styles.contenitoreTabella} style={{marginTop: "2px"}}>
                    <Table
                        cols={this.cols} rows={this.state.rows}
                        empty={this.state.rows && this.state.rows.length == 0 && this.cols.sortRows}
                        onSelectCheckbox={this.selectRow}
                        emptyMsg={t("Tables.Home.noSegnalazioni")}
                        lengthEditable={true}
                        bigTable={true}
                        totalElements={this.state.totalElements}
                        totalPages={this.state.totalPages}
                        page={this.state.page}
                        changePage={this.changePageTable}
                        changePagination={this.changePaginationTable}
                    />
                </div>
            </div>
        );

        const buttonDiv = (
            <div className={"row"} style={{marginTop: "5rem"}}>
                <Button text={t("GestioneFocolai.associaSegnalazioni.annulla")}
                        onClick={() => this.backToAssociaFocolaio()}
                        className="btnWhite col-lg-2, col-sm-12 col-lg-3 mx-lg-auto"
                        style={{height: "3rem", marginTop: "1rem"}}></Button>
                <Button text={t("GestioneFocolai.associaSegnalazioni.associa")}
                        className="btnBlu col-lg-2, col-sm-12 col-lg-3 mx-lg-auto"
                        style={{height: "3rem", marginTop: "1rem"}}
                        onClick={() => {
                            if (!this.props.location.infoState.sections.idFocolaio)
                                this.saveBozzaFocolaio()
                            else
                                this.callAssociaFocolaio(this.props.location.infoState.sections.idFocolaio)
                        }}
                        disabled={!this.state.segnalazioniSelezionate || this.state.segnalazioniSelezionate.length == 0}></Button>
            </div>
        )

        const form = (
            <div style={{paddingTop: "2rem"}}>
                <div>
                    <h6>{t("GestioneFocolai.associaSegnalazioni.segnalazioni_correlate")}</h6>
                    <hr className={styles.hr}></hr>
                </div>
                {tableDiv}
                {buttonDiv}
            </div>
        );

        const spinnerDiv = (
            <div>
                <Spinner/>
            </div>
        );

        return (
            <div>
                {ToasterSingleton.instance().renderToaster()}
                {form}
                {this.state.loading ?
                    (<div>{spinnerDiv}</div>) : (<div/>)}
            </div>
        );

    }

}

export default withTranslation('common')(AssociaSegnalazioni)
